export default function (name) {
  if (name === undefined || typeof name !== 'string') return
  const value = `; ${document.cookie}`
  const parts = value.split(`; ${name}=`)
  if (parts.length === 2) return parts.pop().split(';').shift()
}
